module.exports = __webpack_public_path__ + "static/media/c5bannerModul1_small.5ca90cd1.jpg";